import { createContext } from "react";
import { authApi } from "../lib/api";
import type { User } from "../types/api";

export interface LoginResult {
  user: User;
  accountDeletionRecovered: boolean;
}

export interface AuthContextValue {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<LoginResult>;
  register: (payload: Parameters<typeof authApi.register>[0]) => Promise<User>;
  applyTokenUser: (token: string, refreshToken: string, user: User) => void;
  refreshUser: () => Promise<User | null>;
  setUser: (user: User | null) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
